export default "__VITE_ASSET__012f08f7__"